import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { apiRequest } from "@/lib/queryClient";

export type OnShiftStatus = {
  mode: "off" | "shared" | "above" | "every_record";
  threshold: string | null;
  onShift: { userId: string; name: string; confirmedAt: string; expiresAt: string } | null;
  managers: { id: string; name: string }[];
  canManage: boolean;
  canReset: boolean;
};
export function useOnShift(branchId: string) {
  const { user, currentWorkspace } = useAuth();
  const client = useQueryClient();
  const key = ["branch-cash", "on-shift", currentWorkspace?.id, user?.id, branchId];
  const query = useQuery<OnShiftStatus>({
    queryKey: key,
    enabled: !!user && !!currentWorkspace && !!branchId,
    queryFn: async () => (await apiRequest("GET", `/api/cash/on-shift?branchId=${encodeURIComponent(branchId)}`)).json(),
    staleTime: 0,
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
    retry: false,
  });
  return { query, key, update: (status: OnShiftStatus) => client.setQueryData(key, status) };
}